/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // Free-shipping message: data-limit holds the threshold in whole units of the
  // customer's CURRENT currency (theme setting "Fri fragt"). theme.js multiplies
  // it by window.Shopify.currency.rate (it assumed a shop-currency limit), which
  // is wrong for per-currency thresholds, so the amount and the success state
  // are corrected here whenever the rate is not 1. For rate 1 theme.js is right.
  var lastFsCart = null;

  function fsRate() {
    var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    return rate > 0 ? rate : 1;
  }

  function fsFormat(minor) {
    var code = window.theme && window.theme.currencyCode;
    var value = minor / 100;
    var text;
    try {
      text = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      text = String(Math.round(value * 100) / 100);
    }
    if (window.theme && window.theme.settings && window.theme.settings.currency_code_enable && code) {
      text += ' ' + code;
    }
    return text;
  }

  function syncFreeShipping(cart) {
    if (!cart) return;
    lastFsCart = cart;
    var total = cart.total_price || 0;
    document.querySelectorAll('.cart__shipping-message').forEach(function(wrapper) {
      var message = wrapper.querySelector('[data-limit]');
      if (!message) return;

      var limit = parseFloat(message.getAttribute('data-limit')) || 0;
      if (limit <= 0) return;

      var fill = wrapper.querySelector('.cart__shipping-bar__fill');
      if (fill) {
        var percent = Math.min(100, Math.max(0, ((total / 100) / limit) * 100));
        fill.style.width = percent + '%';
      }

      if (fsRate() !== 1) {
        var limitMinor = limit * 100;
        var expected = fsFormat(Math.max(0, limitMinor - total));
        wrapper.querySelectorAll('[data-left-to-spend]').forEach(function(el) {
          if (el.textContent.trim() !== expected) el.textContent = expected;
        });
        var hasQualified = message.getAttribute('data-cart-message') === 'true';
        message.classList.toggle('is-success', hasQualified && total >= limitMinor && total !== 0);
      }
    });
  }

  // theme.js can re-initialise the message (drawer open, empty cart) and write
  // an amount scaled by the rate; keep the amount correct for rate != 1.
  document.addEventListener('DOMContentLoaded', function() {
    if (fsRate() === 1 || !('MutationObserver' in window)) return;
    var observer = new MutationObserver(function() {
      if (lastFsCart) syncFreeShipping(lastFsCart);
    });
    document.querySelectorAll('.cart__shipping-message').forEach(function(wrapper) {
      observer.observe(wrapper, { childList: true, subtree: true, characterData: true });
    });
    if (window.theme && window.theme.routes && window.theme.routes.cart) {
      window.fetch(window.theme.routes.cart + '.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) { syncFreeShipping(cart); })
        .catch(function() {});
    }
  });

  // Keeps the free-shipping progress bar (.cart__shipping-bar__fill) and the
  // cart drawer's Total/Fragt/Du sparer summary (snippets/cart-drawer-summary.liquid)
  // in sync on every AJAX cart change (quantity +/-, add to cart, remove item).
  // Both blocks sit outside the native [data-cart-subtotal]/[data-line-items]
  // containers Pipeline already refreshes, so without this they only update on
  // a full page reload.
  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (!cart) return;

    // Progress bar: purely arithmetic (total_price vs the per-currency
    // threshold already rendered into the data-limit attribute, in whole units
    // of the customer's currency), so it can be patched directly without a
    // server round-trip.
    syncFreeShipping(cart);
    // theme.js (CartShippingMessage) reacts to the same event and may
    // overwrite the "left to spend" amount; re-apply once all listeners ran.
    window.setTimeout(function() { syncFreeShipping(cart); }, 0);

    // Drawer summary: "Du sparer" needs each line item's compare_at_price,
    // which isn't part of the Ajax Cart API payload, so it has to be
    // recomputed server-side. Re-fetch the dedicated api-cart-drawer-summary
    // section (same Section Rendering API pattern Pipeline itself uses for
    // [data-cart-subtotal]) and swap in the fresh HTML.
    var summaryTarget = document.querySelector('[data-cart-drawer-summary]');
    if (summaryTarget && window.theme && window.theme.routes && window.theme.routes.root_url) {
      window.fetch(window.theme.routes.root_url + '?section_id=api-cart-drawer-summary')
        .then(function(response) { return response.text(); })
        .then(function(html) {
          var fresh = document.createElement('div');
          fresh.innerHTML = html;
          var content = fresh.querySelector('[data-api-content]');
          if (content) {
            summaryTarget.innerHTML = content.innerHTML;
          }
        })
        .catch(function(e) { console.error(e); });
    }
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
